import { Instagram, Facebook, Youtube, Linkedin } from 'lucide-react';

const socialLinks = [
  { icon: Instagram, label: 'Instagram', href: '#' },
  { icon: Facebook, label: 'Facebook', href: '#' },
  { icon: Youtube, label: 'YouTube', href: '#' },
  { icon: Linkedin, label: 'LinkedIn', href: '#' },
];

export default function FooterSection() {
  return (
    <footer className="py-16 md:py-20 px-6 md:px-12 lg:px-24 border-t border-white/[0.04]" data-testid="footer-section">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-10">
          {/* Brand */}
          <div className="text-center md:text-left">
            <h3 className="font-heading text-xl tracking-[0.15em] text-gold">OZFEST</h3>
            <p className="text-zinc-700 text-xs font-body mt-1.5 tracking-wider">
              Resorts World, Las Vegas
            </p>
          </div>

          {/* Social */}
          <div className="flex items-center gap-8">
            {socialLinks.map(({ icon: Icon, label, href }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-zinc-600 hover:text-gold transition-colors duration-300"
                data-testid={`social-${label.toLowerCase()}`}
                aria-label={label}
              >
                <Icon className="w-[18px] h-[18px]" strokeWidth={1.5} />
              </a>
            ))}
          </div>

          {/* Nav */}
          <div className="flex items-center gap-8">
            {[
              { label: 'About', href: '#intro' },
              { label: 'Experience', href: '#experience' },
              { label: 'Contact', href: '#contact' },
            ].map(({ label, href }) => (
              <a
                key={label}
                href={href}
                className="text-zinc-600 text-[10px] tracking-[0.2em] uppercase font-body hover:text-gold transition-colors duration-300"
              >
                {label}
              </a>
            ))}
          </div>
        </div>

        <div className="w-full h-[1px] bg-white/[0.04] my-10" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-zinc-800 text-[10px] font-body tracking-wider">
          <p>&copy; {new Date().getFullYear()} OZFEST. All rights reserved.</p>
          <p>Sport. Culture. Energy.</p>
        </div>
      </div>
    </footer>
  );
}
